module.exports = __webpack_public_path__ + "media/assets/images/icon_gear@2x-8b854bd0554d8f00a2974e9bbbe6ba0a.png";